import React, { Component, Fragment } from 'react';

class CartTotal extends Component {
  render() {
    const { cartTotal, cart, clearCart } = this.props.value;
    const emptyCart = cart.length === 0 ? true : false;
    return (
      <Fragment>
        {!emptyCart && (
          <div>
            <button
              className='btn cart-btn clear-cart'
              onClick={() => {
                clearCart();
              }}
            >
              Clear Cart
            </button>
            <p className='bold'>Total: ${cartTotal.toFixed(2)}</p>
          </div>
        )}
      </Fragment>
    );
  }
}

export default CartTotal;
